


































































import Vue from 'vue';
import { Component, Prop, Watch } from 'vue-property-decorator';
import { UsersData } from '@attensi/api-js';

import Language from './Language.vue';
import { LocaleEnum } from '../../language';

@Component({
  components: { Language },
})
export default class LanguageSelect extends Vue {
  data() {
    return {
      LocaleEnum,
    };
  }

  languageSelectOpen: boolean = false;

  @Prop({ default: null })
  user!: UsersData | null;

  @Watch('user', { immediate: true })
  onUserChanged(value: string, oldValue: string) {
    if (!this.user) { return; }
    if (!this.user.locale) { return; }
    const locale = this.user.locale;
    if (locale === 'nb-NO') {
      this.SetLocale(LocaleEnum.no);
    } else if (locale === 'en-US') {
      this.SetLocale(LocaleEnum.en);
    }
  }

  SetLocale(locale: LocaleEnum) {
    this.$i18n.locale = locale;
  }

  openLanguageSelect() {
    this.languageSelectOpen = true;
    document.addEventListener('click', this.closeLanguageSelect);
  }
  closeLanguageSelect(event: any) {
    if (!event.path) {
      this.closeLanguageSelectFallback(event);
      return;
    }
    const path = event.path || (event.composedPath && event.composedPath());
    const clickInside: boolean = path.find(
      (parent: any) => parent.id === 'navbar',
    )
      ? true
      : false;
    if (!clickInside) {
      document.removeEventListener('click', this.closeLanguageSelect);
      this.languageSelectOpen = false;
    }
  }
  closeLanguageSelectFallback(event: any) {
    const close = true;
    let current = event.target.parentElement;
    while (current) {
      if (current.id === 'navbar') {
        return;
      }
      current = current.parentElement;
    }
    document.removeEventListener('click', this.closeLanguageSelect);
    this.languageSelectOpen = false;
  }
}
